<dx-toast #toast
          [displayTime]="5000"
          [contentTemplate]="toastContentType">
  <dxo-position my="left bottom"
                at="left bottom"
                of="#screen"
                offset="40 -40">
  </dxo-position>
  <div *dxTemplate="let data of 'create'">
    <label>Success!</label>
    <div>Created {{entityName}} successfully</div>
  </div>
  <div *dxTemplate="let data of 'save'">
    <label>Success!</label>
    <div>Updated {{entityName}} successfully</div>
  </div>
  <div *dxTemplate="let data of 'reset'">
    <label>Success!</label>
    <div>{{entityName}} details were reset</div>
  </div>
  <div *dxTemplate="let data of 'delete'">
    <label>Success!</label>
    <div>Deleted {{entityName}} successfully</div>
  </div>
  <div *dxTemplate="let data of 'error'">
    <label>Error!</label>
    <div>{{ toastMessage }}</div>
  </div>
  <div *dxTemplate="let data of 'custom'">
    <label>{{ toastTitle }}</label>
    <div>{{ toastMessage }}</div>
  </div>
</dx-toast>